<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" :width="width" :height="height"><g stroke-linecap="round" stroke-linejoin="round" :stroke-width="strokewidth" :fill="_secondaryfill" :stroke="_secondaryfill"><path d="M1.248,27,14.2,3.071a2.051,2.051,0,0,1,3.6,0L30.752,27a2.036,2.036,0,0,1-1.8,3H3.05A2.036,2.036,0,0,1,1.248,27Z" fill="none" :stroke="fill"></path><line x1="16" y1="10" x2="16" y2="20" fill="none" :stroke="_secondaryfill"></line><circle cx="16" cy="24.5" r="1.5" stroke="none"></circle></g></svg></template>

<script>
export default {
	props: {
		width: {
			type: [Number, String],
			default: "100%"
		},
		height: {
			type: [Number, String],
			default: "100%"
		},
		strokewidth: {
			type: [Number, String],
			default: 1
		},
		fill: {
			type: String,
			default: "currentColor"
		},
		secondaryfill: {
			type: String
		}
	},
	computed: {
		_secondaryfill: function () {
			return this.secondaryfill || this.fill
		}
	}
}
</script>